module.exports = __webpack_public_path__ + "static/bottom-segment@2x-7b5129e689e832042a674cb92e4e90e9.png";